import { SignalConfig } from "./SignalConfig";
import { LeanToWraparoundSetting } from "./LeanToWraparoundSetting";

export class LeanToSettingConfig
{
	public enabled   : SignalConfig<boolean>;
	public length    : SignalConfig<number>;
	public pitch     : SignalConfig<number>;
	public drop      : SignalConfig<number>;
	public cut_front : SignalConfig<number>;
	public cut_back  : SignalConfig<number>;

	public wraparound_back  : LeanToWraparoundSetting;
	public wraparound_front : LeanToWraparoundSetting;
	public id : string;

	constructor(setting)
	{
		this.enabled   = new SignalConfig<boolean>({value: setting.enabled});
		this.length    = this.createSignalConfig(setting.length);
		this.pitch     = this.createSignalConfig(setting.pitch);
		this.drop      = this.createSignalConfig(setting.drop);
		this.cut_front = this.createSignalConfig(setting.cut_front);
		this.cut_back  = this.createSignalConfig(setting.cut_back);
	}

	public setWraparoundSettings(top:LeanToWraparoundSetting, bottom:LeanToWraparoundSetting)
	{
		this.wraparound_back = top;
		this.wraparound_front = bottom;
	}

	private createSignalConfig(config)
	{
		
		var signalConfig = new SignalConfig<number>({
			min: config.min,
			max: config.max,
			value: config.value
		});

		return signalConfig;
	}

	public getRealLength():number
	{
		return this.enabled.value ? this.length.value : 0;
	}
}